export function initTournamentSeasonSelects(parsedSettings, activatingFunction) {
    const currentUrl = new URL(window.location);
    const currentTournamentId = currentUrl.searchParams.get('tournamentId');
    const currentSeasonId = currentUrl.searchParams.get('seasonId');

    initTournamentSelects();
    tournamentSelectHandler();
    seasonSelectHandler();

    function initTournamentSelects() {
        const tournamentSelect = $('[data-tournament-select]');
        let dataTournamentSettings = [];

        for (let i = 0; i < parsedSettings.length; i++) {

            dataTournamentSettings.push({
                "id": parsedSettings[i].id,
                "text": parsedSettings[i].name,
                "selected": parsedSettings[i].id === currentTournamentId
            });
        }

        tournamentSelect.select2({
            data: dataTournamentSettings,
            theme: 'default',
            minimumResultsForSearch: Infinity,
            dropdownParent: tournamentSelect.parent()
        });

        currentUrl.searchParams.set('tournamentId', tournamentSelect.val());
        updateSeasonSelect();
    }

    function updateSeasonSelect() {
        const selectedTournamentId = $('[data-tournament-select]').val();
        const seasonSelect =  $('[data-season-select]');
        let seasons = [];

        for (let i = 0; i < parsedSettings.length; i++) {
            if (+parsedSettings[i].id === +selectedTournamentId) {

                seasons = parsedSettings[i].seasons.map((item, index) => {
                    return {
                        id: item.id,
                        text: item.name,
                        selected:  item.id === currentSeasonId ? item.id === currentSeasonId : index === 0,
                    }
                })
            }
        }


        seasonSelect.html('').select2({
            data: seasons,
            theme: 'default',
            minimumResultsForSearch: Infinity,
            dropdownParent: seasonSelect.parent()
        })

        currentUrl.searchParams.set('seasonId', seasonSelect.val());
    }

    function tournamentSelectHandler() {
        const tournamentSelect = $('[data-tournament-select]');

        tournamentSelect.on('change', () => {
            currentUrl.searchParams.set('tournamentId', tournamentSelect.val());
            currentUrl.searchParams.delete('seasonId');
            window.location = currentUrl;
            updateSeasonSelect();
            activatingFunction();
        })
    }

    function seasonSelectHandler() {
        const seasonSelect = $('[data-season-select]');

        seasonSelect.on('change', () => {
            currentUrl.searchParams.set('seasonId', seasonSelect.val());
            window.location = currentUrl;
            activatingFunction();
        })
    }
}
